(() => {
    const menuHandle = document.getElementById('menu-handle');
    const menuContainer = document.getElementById('mobile-menu-container');
    const menu = document.getElementById('mobile-menu');

    const showMenu = (e) => {
        if (e) e.preventDefault();

        menuContainer.classList.remove('--hidden');
    };

    const hideMenu = (e) => {
        if (e.target === menuContainer) {
            e.preventDefault();

            menuContainer.classList.add('--hidden');
        }
    };

    menuHandle.addEventListener('click', showMenu);
    menuContainer.addEventListener('click', hideMenu);
})();
